export const MODEL_FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  address: 'address',
  postcode: 'postcode',
  city: 'city',
  country: 'country',
  birthday: 'birthday',
  // for additional account owner
  birthdate: 'birthdate',
  oldIban: 'oldIban',
  newIban: 'newIban',
  branchId: 'branchId',
  email: 'emailAddress',
  additionalAccountOwners: 'additionalAccountOwners',
  acceptDebitspecialDate: 'acceptDebitspecialDate',
  acceptStandingOrderspecialDate: 'acceptStandingOrderspecialDate',
  accountswitchSpecificDate: 'accountswitchSpecificDate',
  refuseStandingOrders: 'refuseStandingOrders',
  refuseStandingOrdersDeadline: 'refuseStandingOrdersDeadline',
  accountCloseDeadline: 'accountCloseDeadline',
  closeAccount: 'closeAccount',
  transferBalanceDeadline: 'transferBalanceDeadline',
  transferBalance: 'transferBalance',
  refuseDebitsAndDepositsPartner: 'refuseDebitsAndDepositsPartner',
  refuseDebitsAndDepositsPartnerDeadline:
    'refuseDebitsAndDepositsPartnerDeadline',
  // Only used on payment partners letter
  acceptDebitDateForPaymentpartners: 'acceptDebitDateForPaymentpartners',
  acceptDepositsDateForPaymentpartners: 'acceptDepositsDateForPaymentpartners',
  acceptDebits: 'acceptDebits',
  acceptStandingOrders: 'acceptStandingOrders',
  acceptDepositsAskForInformationCustomerSelectable:
    'acceptDepositsAskForInformationCustomerSelectable',
  acceptDepositsAskForInformationPaymentPartnerSelectable:
    'acceptDepositsAskForInformationPaymentPartnerSelectable',
  acceptDebitsAskForInformationCustomerSelectable:
    'acceptDebitsAskForInformationCustomerSelectable',
  acceptDebitsAskForInformationPaymentPartnerSelectable:
    'acceptDebitsAskForInformationPaymentPartnerSelectable',
  acceptDebitsCertainSpecialPaymentPartnerListMultiplier:
    'acceptDebitsCertainSpecialPaymentPartnerListMultiplier',
  dispatchAddress: 'dispatchAddress',
  dispatchAddressAddress: 'dispatchAddress_address',
  dispatchAddressPostcode: 'dispatchAddress_postcode',
  dispatchAddressCity: 'dispatchAddress_city',
  dispatchAddressCountry: 'dispatchAddress_country',
};

export const SIBLING_FIELDS = {
  [[MODEL_FIELDS.refuseDebitsAndDepositsPartnerDeadline]]: [
    MODEL_FIELDS.accountswitchSpecificDate,
    MODEL_FIELDS.acceptDebitDateForPaymentpartners,
    MODEL_FIELDS.acceptDepositsDateForPaymentpartners,
    MODEL_FIELDS.refuseStandingOrdersDeadline,
    MODEL_FIELDS.transferBalanceDeadline,
    MODEL_FIELDS.accountCloseDeadline,
    MODEL_FIELDS.acceptDebitspecialDate,
    MODEL_FIELDS.acceptStandingOrderspecialDate,
  ],
};

export const ACCOUNTSWITCH_INITIAL_WEEKS_SHIFT = {
  [MODEL_FIELDS.acceptDebitspecialDate]: 6,
  [MODEL_FIELDS.accountswitchSpecificDate]: 6,
  [MODEL_FIELDS.refuseStandingOrdersDeadline]: 6,
  [MODEL_FIELDS.acceptStandingOrderspecialDate]: 6,
  [MODEL_FIELDS.accountCloseDeadline]: 6,
  [MODEL_FIELDS.transferBalanceDeadline]: 6,
  [MODEL_FIELDS.acceptDebitDateForPaymentpartners]: 6,
  [MODEL_FIELDS.acceptDepositsDateForPaymentpartners]: 6,
  [MODEL_FIELDS.refuseDebitsAndDepositsPartnerDeadline]: 6,
};
